import React, { useState } from "react";
import { toast } from "react-toastify";
import { getUserToken } from "../../../utils/localStoarege";
import { localToken, BASE_URL } from "../../../constants/apis/new_hud_apis";

const Pagination = ({
  currentPage,
  pageSize,
  totalEntries,
  data,
  setTableData,
  onPageChange,
  onPageSizeChange,
}) => {
  const [selectedPageSize, setSelectedPageSize] = useState(pageSize);

  // Calculate total pages
  const totalPages = Math.ceil(totalEntries / selectedPageSize);

  const handlePrevious = () => {
    if (data?.previous) {
      fetchPage(data.previous.replace("http://", "https://"));
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (data?.next) {
      fetchPage(`${data.next.replace("http://", "https://")}`);
      onPageChange(currentPage + 1);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    setSelectedPageSize(newSize);
    onPageSizeChange(newSize);
  };

  const fetchPage = async (link) => {
    try {
      const isHudApiLink = link.includes("hud.mvrc.co.in");
      const isNewClinicApiLink = link.includes("newclinic.mvrc.co.in") || link.startsWith(BASE_URL);
      const token = (isHudApiLink || isNewClinicApiLink) ? localToken : getUserToken();

      const response = await fetch(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (response.ok) {
        const newData = await response.json();
        setTableData(newData);
      } else {
        throw new Error(`Failed to fetch: ${response.status}`);
      }
    } catch (error) {
      let errors =
        error?.response?.data?.error || "Oops! Something went wrong, please try again.";
      toast.error(errors);
    }
  };

  return (
    <div className="flex flex-wrap justify-between items-center py-4 gap-4">
      {/* Pagination Details */}
      {data && data?.results && data?.results?.length > 0 ? (
        <div className="text-sm text-black">
          Total Data:{" "}
          <span className="font-bold">{totalEntries}</span> | Showing Page{" "}
          <span className="font-bold">{currentPage}</span> of{" "}
          <span className="font-bold">{totalPages}</span>

          {/* <label htmlFor="pageSize" className="text-sm font-medium mx-4">
            Page Size:
          </label>
          <select
            id="pageSize"
            value={selectedPageSize}
            onChange={handlePageSizeChange}
            className="border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select> */}
        </div>
      ) : (
        <div className="text-gray-500">No data available</div>
      )}

      {/* Pagination Buttons */}
      <div className="flex space-x-2">
        {/* Previous Button */}
        <button
          onClick={handlePrevious}
          disabled={!data?.previous}
          className="w-8 h-8 flex items-center justify-center bg-primary text-white rounded-full disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Previous"
        >
          {/* Left Arrow Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
            className="w-4 h-4"
          >
            <path
              fillRule="evenodd"
              d="M12.293 4.293a1 1 0 010 1.414L8.414 10l3.879 4.293a1 1 0 01-1.415 1.414l-4.586-5a1 1 0 010-1.414l4.586-5a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        {/* Next Button */}
        <button
          onClick={handleNext}
          disabled={!data?.next}
          className="w-8 h-8 flex items-center justify-center bg-primary text-white rounded-full disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Next"
        >
          {/* Right Arrow Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
            className="w-4 h-4"
          >
            <path
              fillRule="evenodd"
              d="M7.707 4.293a1 1 0 010 1.414L11.586 10l-3.879 4.293a1 1 0 101.415 1.414l4.586-5a1 1 0 000-1.414l-4.586-5a1 1 0 00-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
